import { OrderItemInfo } from 'appTypes/orders'

import { normalizeUrl } from './normalizeUrl'

export const getPaymentSelectPageUrl = (
  orderId: number,
  orderItemId: number | undefined,
  purchaseAs: string,
  reconciliation?: boolean,
): string => {
  let url = `/payment/select?orderId=${orderId}`
  if (orderItemId !== undefined) {
    url += `&orderItemId=${orderItemId}`
  }
  url += `&purchaseAs=${purchaseAs}`
  if (reconciliation !== undefined) {
    url += `&reconciliation=${reconciliation}`
  }
  return url
}

export const redirectToCartPage = (): string => {
  return '/cart'
}

export const getProlongationPageUrl = (orderItemInfo: OrderItemInfo): string => {
  const { orderItem, parentBundleItem } = orderItemInfo

  const isBundle = orderItem.parentBundleOrderItemId !== undefined
  const { rentedFrom, rentedTo, orderId, id, parentBundleOrderItemId, locationId, regionId } = orderItem

  const productId = parentBundleItem?.productId ?? orderItem.productId
  const productData = parentBundleItem?.productData ?? orderItem.productData

  const url = `/${isBundle ? 'bundles' : 'products'}/${normalizeUrl(productData?.name ?? '', productId)}`

  const queryParts = new URLSearchParams()
  queryParts.append(`isProlonging`, `true`)
  queryParts.append(`orderId`, orderId.toString())
  queryParts.append(`orderItemId`, (parentBundleOrderItemId ?? id).toString())
  queryParts.append(`locationId`, locationId?.toString() ?? '')
  queryParts.append(`regionId`, regionId?.toString() ?? '')
  queryParts.append(`rentedFrom`, rentedFrom?.toISOString() ?? '')
  queryParts.append(`rentedTo`, rentedTo?.toISOString() ?? '')

  const result = `${url}?${queryParts.toString()}`
  return result
}
